import DetailsModal from './details-modal.connect'

export default DetailsModal
